module.exports = __webpack_public_path__ + "img/Wechat_icon.1e45e3a.svg";